import React from "react";
import {
  TacticLoader,
  TacticLoaderProps
} from "@v2/components/loaders/TacticLoader/TacticLoader";
import { useCloseAnimationTimeout } from "@gettactic/helpers/src/hooks/useCloseAnimationTimeout";
import { cn, useBooleanState } from "@gettactic/helpers";

const classes = {
  Container: "fixed inset-0 flex items-center justify-center transition-opacity"
};

export interface FullPageLoader extends TacticLoaderProps {
  isLoading: boolean;
  showDelay?: number;
  hideDelay?: number;
}

export const FullPageLoader: React.FC<FullPageLoader> = ({
  isLoading,
  className,
  showDelay = 100,
  hideDelay = 0,
  ...loadingProps
}) => {
  const _isLoading = useBooleanState();
  const { isVisible } = useCloseAnimationTimeout(_isLoading.state ?? true);

  React.useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (isLoading) {
      if (showDelay > 0) {
        timer = setTimeout(() => _isLoading.true(), showDelay);
      } else {
        _isLoading.true();
      }
    } else {
      if (hideDelay > 0) {
        timer = setTimeout(() => _isLoading.false(), hideDelay);
      } else {
        _isLoading.false();
      }
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isLoading, showDelay, hideDelay]);

  if (!isVisible) return null;

  return (
    <div
      className={cn(
        classes.Container,
        isLoading ? "opacity-100" : "opacity-0",
        className
      )}
    >
      <TacticLoader className={"opacity-60"} {...loadingProps} />
    </div>
  );
};
